module.exports = __webpack_public_path__ + "static/media/MapImage.394fe56d.png";